/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageField
 */
export interface LanguageField extends UpdatedField {
    /**
     * 
     * @type {string}
     * @memberof LanguageField
     */
    value: string;
}

/**
 * Check if a given object implements the LanguageField interface.
 */
export function instanceOfLanguageField(value: object): value is LanguageField {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function LanguageFieldFromJSON(json: any): LanguageField {
    return LanguageFieldFromJSONTyped(json, false);
}

export function LanguageFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
    };
}

export function LanguageFieldToJSON(value?: LanguageField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
    };
}

